import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { useLocation } from 'react-router-dom';

import ColoredSectionContainer from 'components/no-auth/common/ColoredSectionContainer';
import FaqSection from 'components/no-auth/common/sections/FaqSection';
import HeadingSection from 'components/no-auth/common/sections/HeadingSection';
import { HeroSection } from 'components/no-auth/common/sections/HeroSection';
import LoneButtonSection from 'components/no-auth/common/sections/LoneButtonSection';
import { TilesSection } from 'components/no-auth/common/sections/TilesSection';
import TrustpilotSection from 'components/no-auth/common/sections/TrustpilotSection';
import NotAuthBasePage from 'components/no-auth/NotAuthBasePage';

import Cookies from 'universal-cookie';

const BonusPage = (props) => {
    const location = useLocation();

    useEffect(() => {
        const cookies = new Cookies();
        let pathname = location.pathname;
        let arr = pathname.split('/');
        let inviteCode = arr.pop();
        if (arr.includes('referral') && inviteCode) {
            const expirationDate = new Date();
            expirationDate.setFullYear(expirationDate.getFullYear() + 1);
            cookies.set('invite_code', inviteCode, { path: '/', expires: expirationDate });
        }
    }, []);

    return (
        <>
            {props.heroTitle && (
                <HeroSection
                    title={props.heroTitle}
                    text={props.heroText}
                    img={props.heroImg}
                    data={props.heroData}
                    btnVariant={'primary'}
                    isInvertedBtn
                    noIconBtn
                />
            )}
            <ColoredSectionContainer>
                {props.headline1Title && <HeadingSection title={props.headline1Title} text={props.headline1Text} />}
                {props.tiles && <TilesSection data={props.tiles} grayText loadingLazy />}
                {props.termsLink && <LoneButtonSection btn={props.termsLink} variant="tertiary" />}
                {props.lang && <TrustpilotSection lang={props.lang} />}
                {props.tiles2 && <TilesSection data={props.tiles2} grayText lang={props.lang} country={props.country} loadingLazy />}
            </ColoredSectionContainer>
            {props.faqTitle && props.questions && <FaqSection title={props.faqTitle} questions={props.questions} noTopPadding />}
        </>
    );
};

const mapStateToProps = (state) => {
    return {
        heroTitle: state.extra?.strapiApi?.hero_block?.title,
        heroText: state.extra?.strapiApi?.hero_block?.text,
        heroData: state.extra?.strapiApi?.hero_block,
        heroBgImg: state.extra?.strapiApi?.hero_block?.bgImg,
        heroImg: state.extra?.strapiApi?.hero_block?.img,

        headline1Title: state.extra?.strapiApi?.headline1?.title,
        headline1Text: state.extra?.strapiApi?.headline1?.text,

        tiles: state.extra?.strapiApi?.tiles_section,
        tiles2: state.extra?.strapiApi?.tiles_section_2,

        termsLink: state.extra?.strapiApi?.terms_link,

        faqTitle: state.extra?.strapiApi?.faq?.title,
        questions: state.extra?.strapiApi?.faq?.questions,

        lang: state.extra.noAuthFooter?.language?.lang,
        country: state.extra.noAuthFooter?.language?.country,
    };
};

export default connect(mapStateToProps)(NotAuthBasePage(BonusPage));
